/**
 * BSC Costs (BAB) API client. Every endpoint is a GET — the allocation rules stay
 * maintained in bab-process-app-v2, which shares the tables with the nightly ADF path.
 */
import { fetchApi } from './api';
import type { BscPeriod, BscDimensions, BscReconciliation, BscFiltersState } from '../types/babBsc';

/** Scope filters as query params; 'ALL' and '' mean "no filter" and are dropped. */
export function toApiFilters(f: BscFiltersState): Record<string, string> {
    const out: Record<string, string> = {};
    if (f.selectedBabCompanyCode && f.selectedBabCompanyCode !== 'ALL') {
        out.babCompanyCode = f.selectedBabCompanyCode;
    }
    if (f.selectedBuCode && f.selectedBuCode !== 'ALL') out.buCode = f.selectedBuCode;
    if (f.selectedSourceCompany) out.sourceCompany = f.selectedSourceCompany;
    return out;
}

function qs(params: Record<string, string | number | undefined>): string {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
    }
    const s = q.toString();
    return s ? `?${s}` : '';
}

export const babBscApi = {
    getPeriods(): Promise<BscPeriod[]> {
        return fetchApi<BscPeriod[]>('/bab-bsc/periods');
    },

    getDimensions(): Promise<BscDimensions> {
        return fetchApi<BscDimensions>('/bab-bsc/dimensions');
    },

    getReconciliation(
        year: number,
        month: number,
        filters: Record<string, string> = {}
    ): Promise<BscReconciliation> {
        return fetchApi<BscReconciliation>(
            `/bab-bsc/reconciliation${qs({ year, month, ...filters })}`
        );
    },
};
